<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-1" id="dixie"></div>
<div class="calibre1" id="dixie1">
<div class="calibre1" id="toc">
<p class="toc">Table of Contents</p>
<p class="toc"><br/></p>
<div class="calibre1">
<p class="toc"><a href="#/Text/Acknowledgments#toc-anchor">ACKNOWLEDGEMENTS</a></p>
<p class="toc"><a href="#/Text/Preface#toc-anchor-1">Preface — That Window</a></p>
<p class="toc"><a href="#/Text/Chapter_01#toc-anchor-2">Chapter 1 — Rumors</a></p>
<p class="toc"><a href="#/Text/Chapter_02#toc-anchor-3">Chapter 2 — Doomed Marriage</a></p>
<p class="toc"><a href="#/Text/Chapter_03#toc-anchor-4">Chapter 3 — Early Years</a></p>
<p class="toc"><span href="#/Text/Chapter_04#toc-anchor-5" title="Link target outside of Sample">Chapter 4 — Prince Charming</span></p>
<p class="toc"><span href="#/Text/Chapter_05#toc-anchor-6" title="Link target outside of Sample">Chapter 5 — Fateful Decision</span></p>
<p class="toc"><span href="#/Text/Chapter_06#toc-anchor-7" title="Link target outside of Sample">Chapter 6 — Where’s Scott?</span></p>
<p class="toc"><span href="#/Text/Chapter_07#toc-anchor-8" title="Link target outside of Sample">Chapter 7 — The Search Begins</span></p>
<p class="toc"><span href="#/Text/Chapter_08#toc-anchor-9" title="Link target outside of Sample">Chapter 8 — The House</span></p>
<p class="toc"><span href="#/Text/Chapter_09#toc-anchor-10" title="Link target outside of Sample">Chapter 9 — The Discovery</span></p>
<p class="toc"><span href="#/Text/Chapter_10#toc-anchor-11" title="Link target outside of Sample">Chapter 10 — The Autopsy</span></p>
<p class="toc"><span href="#/Text/Chapter_11#toc-anchor-12" title="Link target outside of Sample">Chapter 11 — Dixie’s Arrest</span></p>
<p class="toc"><span href="#/Text/Chapter_12#toc-anchor-13" title="Link target outside of Sample">Chapter 12 — Money Trouble</span></p>
<p class="toc"><span href="#/Text/Chapter_13#toc-anchor-14" title="Link target outside of Sample">Chapter 13 — The Prosecutor</span></p>
<p class="toc"><span href="#/Text/Chapter_14#toc-anchor-15" title="Link target outside of Sample">Chapter 14 — Dixie’s Gamble</span></p>
<p class="toc"><span href="#/Text/Chapter_16#toc-anchor-16" title="Link target outside of Sample">Chapter 16 — Cross-Examination</span></p>
<p class="toc"><span href="#/Text/Chapter_17#toc-anchor-17" title="Link target outside of Sample">Chapter 17 — The Shotgun</span></p>
<p class="toc"><span href="#/Text/Chapter_18#toc-anchor-18" title="Link target outside of Sample">Chapter 18 — Missed Opportunity</span></p>
<p class="toc"><span href="#/Text/Chapter_19#toc-anchor-19" title="Link target outside of Sample">Chapter 19 — Judgment Day</span></p>
<p class="toc"><span href="#/Text/Chapter_20#toc-anchor-20" title="Link target outside of Sample">Chapter 20 — Dixie’s Next Decade</span></p>
<p class="toc"><span href="#/Text/Chapter_21#toc-anchor-21" title="Link target outside of Sample">Chapter 21 — Denial</span></p>
</div>
</div>
<div class="calibre3" id="calibre_pb_5"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?a1c51d7a